import { Component, Input, OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss'],
  imports: [MatTooltipModule]
})
export class SwitcherComponent implements OnInit {

  @Input() labels: { label: string, tooltip: string }[] = [];
  @Input() currentValue: string = '';
  @Input() onToggle: (value: string) => void;

  constructor() { }

  ngOnInit(): void {
  }

  onClick(value: string) {
    if (this.currentValue !== value) {
      this.currentValue = value;
      this.onToggle(value);
    }
  }

}
